export default "__VITE_ASSET__DRVj5bTu__"